(function ($) {
    'use strict';
    $(document).ready(function () {

        var form = document.getElementById('csl_channel_edit_payment_form');

        if (!window.Stripe || !form.length) {
            return;
        }

        // Create a Stripe client
        var stripe = window.Stripe($(form).data('pk'));

        var stripeTokenHandler = function (token) {
            // Insert the token ID into the form so it gets submitted to the server
            $("#csl_channel_edit_payment_stripeToken").val(token.id);

            // Submit the form
            form.submit();
        };

        // Create an instance of Elements
        var elements = stripe.elements();

        // Custom styling can be passed to options when creating an Element.
        // (Note that this demo uses a wider set of styles than the guide below.)
        var style = {
            base: {
                color: '#32325d',
                lineHeight: '24px',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
        };

        // Create an instance of the card Element
        var card = elements.create('card', {style: style});

        // Add an instance of the card Element into the `card-element` <div>
        card.mount('#card-element');

        // Handle real-time validation errors from the card Element.
        card.addEventListener('change', function (event) {
            var displayError = document.getElementById('card-errors');
            if (event.error) {
                displayError.textContent = event.error.message;
            } else {
                displayError.textContent = '';
            }
        });

        // Handle form submission
        form.addEventListener('submit', function (event) {
            event.preventDefault();

            stripe.createToken(card).then(function (result) {
                if (result.error) {
                    // Inform the user if there was an error
                    var errorElement = document.getElementById('card-errors');
                    errorElement.textContent = result.error.message;

                    $(form).removeClass('loading');
                } else {
                    // Send the token to your server
                    stripeTokenHandler(result.token);
                }
            });
        });

    });
})(jQuery);